import { createSelector } from '@reduxjs/toolkit';
import { selectBulk } from '../selectors';
import { BulkState } from '../types';

export const selectReport = createSelector(selectBulk, (bulkState: BulkState) => bulkState.report);
